import { useGetCardHolderWithId as useGetCardHolderWithIdQuery } from '@xhype/card-app-sdk';
import { useAuthStore } from '@package/smart-wallet/store';

/* Types */
type UseGetCardHolderDataWithIdProps = {
  holderId?: number;
};

/* Hook */
export const useGetCardHolderDataWithId = ({
  holderId,
}: UseGetCardHolderDataWithIdProps) => {
  const id = useAuthStore((store) => store.id);

  /* Queries */
  const {
    data: cardHolderInfo,
    isLoading,
    isError,
  } = useGetCardHolderWithIdQuery({
    enabled: !!holderId,
    userId: id ?? 0,
    holderId: holderId ?? 0,
  });

  /* Return */
  return {
    isLoading,
    cardHolderInfo,
    isError,
  };
};
